module.exports = __webpack_public_path__ + "img/game_gfish_x.78c37e1.jpg";